const WHEEL_SWIPE_MIN_DISTANCE = 48;
const WHEEL_SWIPE_DIRECTION_RATIO = 1.25;
const WHEEL_SWIPE_IDLE_MS = 180;

interface WheelNavigationState {
  accumulatedX: number;
  accumulatedY: number;
  lastEventAt: number;
  navigated: boolean;
}

export function resolveWheelNavigation(
  previous: WheelNavigationState,
  event: { deltaX: number; deltaY: number; occurredAt: number },
) {
  const continuesGesture = event.occurredAt - previous.lastEventAt <= WHEEL_SWIPE_IDLE_MS;
  const accumulatedX = (continuesGesture ? previous.accumulatedX : 0) + event.deltaX;
  const accumulatedY = (continuesGesture ? previous.accumulatedY : 0) + event.deltaY;
  const alreadyNavigated = continuesGesture && previous.navigated;
  const isHorizontalSwipe =
    Math.abs(accumulatedX) >= WHEEL_SWIPE_MIN_DISTANCE &&
    Math.abs(accumulatedX) > Math.abs(accumulatedY) * WHEEL_SWIPE_DIRECTION_RATIO;
  const shouldNavigate = !alreadyNavigated && isHorizontalSwipe;
  const swipeDirection = accumulatedX > 0 ? ("next" as const) : ("previous" as const);

  return {
    direction: shouldNavigate ? swipeDirection : null,
    state: {
      accumulatedX,
      accumulatedY,
      lastEventAt: event.occurredAt,
      navigated: alreadyNavigated || shouldNavigate,
    },
  };
}
